import {gsap} from "gsap";

const NBIIndexNumber = function () {
  if (jQuery('.nbi-index-number .number').length === 0) return; //no index number on page

  jQuery('.nbi-index-number .number').css('opacity', 1);
  gsap.from(document.querySelectorAll(".nbi-index-number .number"), {
    textContent: 50,
    opacity:0,
    duration: 1,
    ease: "power1.in",
    onUpdate: function() {
      this.targets()[0].innerHTML = parseFloat(this.targets()[0].textContent).toFixed(1);
    }
  });
}

export { NBIIndexNumber };
